import { useEffect, useMemo } from 'react'
import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { useRecoilValue } from 'recoil'

import { IMG_STORAGE_URL } from '@src/utils/constants'

import vendorAtom from '@src/atom/vendor'
import useGetVendorInfoQuery from '../queries/vendor/useGetVendorInfoQuery'

export default function useChannelTalkService(vendorNo?: string) {
	const vendor = useRecoilValue(vendorAtom)

	const vendorInfo = useGetVendorInfoQuery(vendorNo as string, {
		enabled: !!vendor && vendor.isLoggedIn,
	})

	const userObject = useMemo(() => {
		if (!vendorInfo.data) return {}
		const { name, profile_img, vendor_no } = vendorInfo.data.data.vendor_info
		return {
			avatarUrl: `${IMG_STORAGE_URL}/commerce/vendor/profile_img/${profile_img}`,
			memberId: vendor_no,
			profile: {
				name,
			},
			tags: ['기업_문의'],
		}
	}, [vendorInfo])

	useEffect(() => {
		if (process.env.REACT_APP_CHANNEL_TALK_PULUGIN_KEY) {
			ChannelService.loadScript()
			ChannelService.boot({
				pluginKey: process.env.REACT_APP_CHANNEL_TALK_PULUGIN_KEY,
				...userObject,
			})
		}
	}, [userObject])
}
